import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const fileColumns: GridColumnConfig[] = [
  {
    title: 'File Name',
    field: 'fileName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'File Type',
    field: 'fileType',
    filter: 'text',
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
  },
  // {
  //   title: 'File Section',
  //   field: 'fileSection',
  //   filter: 'text',
  // },
  {
    title: 'Uploaded By',
    field: 'uploadedByFullName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Uploaded On',
    field: 'uploadedOnText',
    filter: 'text',
    searchable: true,
  },
];
